<template>
    <v-row>
        <v-col cols="12" md="10" lg="6" justify="center" offset-md="1" offset-lg="3">
            <v-card class="pa-6" v-if="!previewDocument">
                <v-img class="logo_tam" alt="Logo" :src="envLogo"></v-img>
                <v-card-title class="">Validación de documentos</v-card-title>
                <v-card-subtitle>Para validar tu documento ingresa el folio de verificación ubicado en la parte superior derecha de tu documento en el campo de abajo</v-card-subtitle>
                <v-card-text class="mt-6">
                    <!-- LOGIN FORM -->
                    <v-text-field
                        class=""
                        outlined required
                        label="Ingresa aqui el folio de validación"
                        v-model="documentCode"
                        :rules="[value => !!value || 'El campo es requerido.']"
                    />
                    <v-row class="pl-2 mt-2">
                      <vue-recaptcha
                          :sitekey="getCaptchaSiteKey()"
                          :loadRecaptchaScript="true"
                          @verify="verifyReCaptcha"
                          @expired="expiredRecaptcha"
                          class="mb-2"
                          :align="center"
                      >
                      </vue-recaptcha>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-row align="center" justify="space-around">
                        <div class="d-flex flex-row">
                            <v-btn @click="validate()" color="primary" large class="rounded-0 flex-fill mr-2">Validar documento</v-btn>
                            <v-btn @click="cancelValidate()" color="error" large class="rounded-0 flex-fill ml-2">Cancelar</v-btn>
                        </div>
                    </v-row>
                </v-card-actions>

            </v-card>
            <v-card class="pa-6" v-else>
                <v-img class="logo_tam" alt="Logo" :src="envLogo"></v-img>
                <v-card-title class="">Vista previa del documento</v-card-title>
                <v-card-text>
                    <v-chip class="my-2" color="green" text-color="white" v-if="documentValid">
                        El documento es válido
                    </v-chip>
                    <v-chip class="my-2" color="red" text-color="white" v-else>
                        El documento NO es válido
                    </v-chip>


                    <!-- LOGIN FORM -->
                    <div v-if="documentImages" class="mt-4">
                        <template v-for="(image, index) in documentImages">
                            <v-img
                                :key="'img'+index"
                                :src="image">

                            </v-img>
                        </template>
                    </div>
                    <div v-else class="text-h4 my-16">
                        No se pudo generar una vista previa del documento.
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-row align="center" justify="space-around">
                        <div class="d-flex flex-row">
                            <v-btn @click="validatePageReset()" color="primary" large class="rounded-0 flex-fill mr-2">Validar otro documento</v-btn>
                            <v-btn @click="cancelValidate()" color="error" large class="rounded-0 flex-fill ml-2">Salir</v-btn>
                        </div>
                    </v-row>
                </v-card-actions>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import {GeneralApi} from "@/api";
import {toFormData} from "@/core/utils";

export default {
    data() {
        return {
            envLogo: process.env.VUE_APP_LOGO,
            documentCode: null,
            recaptchaVerified: false,
            formValid: false,
            showPassword: false,
            showRepeatPassword: false,
            documentImages: null,

            previewDocument: false,
            documentValid: false,
        }
    },

    components: {VueRecaptcha},

    computed: {
        ...mapState({accountStore: state => state.account, alertsStore: state => state.alerts}),
    },

    mounted() {
        if (this.$route.query.code !== undefined){
            this.documentCode = this.$route.query.code
        }
    },

    methods: {
        ...mapActions('account', ['setNewUserPassword']),
        ...mapActions('alerts', ['success', 'error', 'showLoading', 'hideLoading']),

        async validate(){
            if (this.documentCode != null && this.recaptchaVerified){
                this.showLoading('Validando el documento, espere un momento.')

                GeneralApi.validateDocument(toFormData({code: this.documentCode}))
                    .then(data => {
                        this.hideLoading()
                        this.success(data.message)
                        this.documentImages = data.content
                        this.previewDocument = true
                        this.documentValid = true
                    })
                    .catch(error => {
                        console.log(error)
                        this.hideLoading()
                        this.error(error.message)
                        this.previewDocument = true
                    })
            }
        },

        validatePageReset(){
            location.reload();
        },

        getCaptchaSiteKey(){
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        verifyReCaptcha(){
            this.recaptchaVerified = true
        },

        expiredRecaptcha(){
            this.recaptchaVerified = false
        },

        cancelValidate(){
            if (this.accountStore.loggedIn){
                this.$router.push({name: 'home'})
            }else{
                this.$router.push({name: 'login'})
            }
        }
    },

};
</script>
<style>
    .relative {position: relative}
    .absolute {position: absolute}
    .fb-native-button{width: 100%;}
    .fb-native-button button{
        height: 36px;
        background-image: none !important;
        padding: 0 !important;
        min-width: 0 !important;
        width: 100%
    }
    .fb-native-button button img, .fb-native-button button .spinner{display: none}
</style>
